module.exports = __webpack_public_path__ + "img/location-pointer.394a052e.svg";